import basePath from "base_path";
import ActionTypes from "../constants/action_types";

import createReduxPromiseAction from "utils/create_redux_promise_action";

export default function documentClausepartsRegexMatchesFetch(requestor) {
  return createReduxPromiseAction(
    ActionTypes.DOCUMENT_CLAUSEPARTS_REGEX_MATCHES_FETCH,
    (organisationId, projectId, documentId) =>
      requestor
        .get(
          `${basePath}/organisation/${organisationId}/project/${projectId}` +
            `/document/${documentId}/document_clauseparts_regex_matches`,
          {withCredentials: true},
        )
        .then(response => response.data),
  );
}
